<app-nav-menu ></app-nav-menu>
<div class="w-full p-2.5">
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
